import { Color, Flex, Link, Text } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { PaperPlane } from '../../../../assets/images'
import { FR_AUTHORITY_URL } from '../../consts/taxAuthoritiesUrls'
import * as Styled from './styles'

export const InfoBox = () => {
  const { t } = useTranslation()

  return (
    <Styled.InfoBox>
      <Flex flexDirection="column">
        <Text color={Color.Purple800} variant="bodySM">
          {t('vat_declarations.info_block')}
        </Text>
        <Text color={Color.Purple800} weight="bold" variant="bodySM">
          <Link underlined href={FR_AUTHORITY_URL} target="_blank">
            impots.gouv.fr
          </Link>
        </Text>
      </Flex>
      <PaperPlane />
    </Styled.InfoBox>
  )
}
